import { BoxNotification } from 'components/containers/BoxNotification';
import * as React from 'react';
import { Modal } from '../../../../components/containers/Modal';
import { ButtonColorsEnum } from '../../../../constants/button-colors';
import classes from './DeleteImporterModal.module.scss';

export type DeleteImporterModalViewProps = {
  onClose: VoidFunction;
  onConfirmation: VoidFunction;
  importerTitle?: string;
  loading: boolean;
};

export const DeleteImporterModalView = ({
  onClose,
  onConfirmation,
  importerTitle,
  loading
}: DeleteImporterModalViewProps): JSX.Element => {
  return (
    <Modal
      title={importerTitle ? 'Delete Auto-Importer' : 'Delete all Auto-Importers'}
      onClose={onClose}
      showCloseIcon={true}
      primaryButtonLoading={loading}
      primaryButtonColor={ButtonColorsEnum.alert}
      primaryButtonTitle={importerTitle ? 'Delete Auto-Importer' : 'Delete All'}
      primaryButtonAction={onConfirmation}>
      {importerTitle ? (
        <p>
          Are you sure you want to delete Auto-Importer <span className={classes.NameImport}>{`${importerTitle}`}</span>
          ?
        </p>
      ) : (
        <p>Are you sure you want to delete all your Auto-Importers?</p>
      )}

      <BoxNotification type={'error'}>
        If deleted, we will stop importing posts from {importerTitle ? 'this source' : 'all sources'}
      </BoxNotification>
    </Modal>
  );
};
